import { useContext } from "react";
import { contextTheme } from "../contexts/ProviderTheme";

export default function Layout({ children }) {
  const { theme } = useContext(contextTheme);

  const style = {
    backgroundColor: !theme ? "#FFF" : "#333",
    color: !theme ? "#333" : "#FFF",
  };

  return <div   style={style} >{children}</div>;
}
